// https://jshakespeare.com/simple-count-up-number-animation-javascript-react/

function getRandomLength(length, range) {
  const min = length - range;
  const max = length + range;
  return Math.floor(Math.random() * (max - min + 1) + min);
}

function animateCountUp (el) {
	// How long you want the animation to take, in ms
	const animationDuration = getRandomLength(3000, 1000);
	// Calculate how long each ‘frame’ should last if we want to update the animation 60 times per second
	const frameDuration = 1000 / 60;
	// Use that to calculate how many frames we need to complete the animation
	const totalFrames = Math.round( animationDuration / frameDuration );
	// An ease-out function that slows the count as it progresses
	const easeOutQuad = t => t * ( 2 - t );

	let frame = 0;

	const countTo = parseInt( el.innerHTML.replaceAll( ',', '' ), 10 );
	// Start the animation running 60 times per second
	const counter = setInterval( () => {
		frame++;
		// Calculate our progress as a value between 0 and 1
		// Pass that value to our easing function to get our
		// progress on a curve
		const progress = easeOutQuad( frame / totalFrames );
		// Use the progress value to calculate the current count
		const currentCount = Math.round( countTo * progress );

		// If the current count has changed, update the element
		if ( parseInt( el.innerHTML, 10 ) !== currentCount ) {
			el.innerHTML = currentCount.toLocaleString();
		}

		// If we’ve reached our last frame, stop the animation
		if ( frame === totalFrames ) {
			clearInterval( counter );
		}
	}, frameDuration );
}

( function( $, window ) {
	'use strict';

	$( function() {
		const statsToCount = [...document.querySelectorAll( '.js-stat-number' )];

		statsToCount.forEach(stat => {
			const parentWaypoint = $(stat.closest( '.js-waypoint' ));

			parentWaypoint.each( function() {
				$( this ).waypoint( {
					handler: function() {
						animateCountUp(stat)
						this.destroy();
					},
					offset: '90%'
				} );
			} );
		});
	} );
} )( jQuery, window );
